// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u_khK","content":"styles_content__32teG","row":"styles_row__3y3eK","footer":"styles_footer__1NWZd","phraseLength":"styles_phraseLength__UUHXl"};